module.exports = __webpack_public_path__ + "img/jg.0bbed5d3.svg";